import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 0px 8px rgba(0, 17, 68, 0.08);
  border-radius: 8px;
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 313px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    height: auto;
  }
`;

export const CarouselWrapper = styled.div`
  width: 244px;
  min-height: 313px;

  & > div {
    width: 100%;
    height: 100%;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    min-height: 200px;
    height: 200px;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
  padding: 24px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
    padding: 16px;
  }
`;

export const TourDetails = styled.div`
  margin-bottom: 12px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-wrap: wrap;
  }
`;

export const TourDetailsItem = styled.div`
  display: flex;
  align-items: center;
`;

export const TourDetailsItemFull = styled(TourDetailsItem)`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex: 0 0 100%;
    width: 100%;
  }
`;

export const TourHeader = styled.div``;

export const TourMainHeaderInfo = styled.div`
  margin-bottom: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 12px;
  }
`;

export const TourTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  width: 100%;
  margin: 0 0 4px 0;
  color: ${({ theme }) => theme.palette.grey1100};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
    width: 100%;
    margin-bottom: 8px;
  }
`;

export const TourBoardTypeWrapper = styled.div``;

export const TourListingItemDetails = styled.div`
  margin-top: 24px;
  position: relative;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 12px;
  }
`;

export const TourBoardType = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.grey600};
`;

export const TourDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.grey300};
  margin: 16px 0;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: none;
  }
`;

export const TourPromotions = styled.div`
  width: 100%;
  margin-top: 16px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 12px 0;
  }
`;

export const PriceWrapper = styled.div`
  padding: 24px 24px 24px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const WorldLogoWrapper = styled.div`
  margin-bottom: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 0;
  }
`;

export const DiscountWrapper = styled.div`
  margin-bottom: 8px;
  align-self: flex-end;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 0;
  }
`;

export const FlexEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const PriceInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const PriceLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.grey600};
  margin-top: 4px;
`;

export const HighLightWrapper = styled.div`
  position: relative;
`;
